import Localization from '~/client/src/shared/localization/LocalizationManager'

import { WidgetId } from './WidgetConfig'

export const getWidgetDescription = (widgetId: WidgetId): string => {
  const { widgetDescriptions } = Localization.translator

  const descriptionMap: Record<WidgetId, string> = {
    [WidgetId.WORKFLOWS_COUNT]: widgetDescriptions.workflowsCount,
    [WidgetId.COMPANIES_COUNT]: widgetDescriptions.companiesCount,
    [WidgetId.USERS_COUNT]: widgetDescriptions.usersCount,
    [WidgetId.AVERAGE_DURATION]: widgetDescriptions.averageDuration,
    [WidgetId.ADVANCED_PLANNING]: widgetDescriptions.advancedPlanning,
    [WidgetId.EQUIPMENT_BOOKINGS_WORKFLOWS]:
      widgetDescriptions.equipmentBookingsWorkflows,
    [WidgetId.EQUIPMENT_BOOKINGS_HOURS]:
      widgetDescriptions.equipmentBookingsHours,
    [WidgetId.LOCATIONS_WORKFLOWS]: widgetDescriptions.locationsWorkflows,
    [WidgetId.LOCATIONS_BY_TYPE]: widgetDescriptions.locationsByType,
    [WidgetId.WORKFLOWS_BY_STATUS]: widgetDescriptions.workflowsByStatus,
    [WidgetId.ACTIVE_VS_COMPLETED]: widgetDescriptions.activeVsCompleted,
    [WidgetId.WORKFLOWS_BY_CATEGORY]: widgetDescriptions.workflowsByCategory,
    [WidgetId.WORKFLOWS_TIMELINE]: widgetDescriptions.workflowsTimeline,
    [WidgetId.RECENT_WORKFLOWS]: widgetDescriptions.recentWorkflows,
  }

  return descriptionMap[widgetId] || ''
}
